/**
 * Application configuration management
 */

import { localStorageManager } from '../storage/local-storage.js';
import { languageManager } from '../lang/language-manager.js';

export class AppConfig {
    constructor() {
        this.config = {
            apiUrl: '/api',
            debounceDelay: 300,
            maxResults: 50,
            pageSize: 20
        };
    }

    // Load application configuration
    async loadConfiguration() {
        const savedConfig = localStorageManager.get('appConfig');
        if (savedConfig) {
            this.config = { ...this.config, ...savedConfig };
        }

        const savedLang = localStorageManager.get('language') || 'ru';
        languageManager.setLanguage(savedLang);
    }

    // Get current configuration
    getConfig() {
        return { ...this.config };
    }

    // Update configuration
    updateConfig(newConfig) {
        this.config = { ...this.config, ...newConfig };
        localStorageManager.set('appConfig', this.config);
    }

    // Apply configuration changes to modules
    applyConfigChanges(modules) {
        if (modules.search) {
            modules.search.searchDebounceDelay = this.config.debounceDelay;
        }

        if (modules.pagination) {
            modules.pagination.setPageSize(this.config.pageSize);
        }
    }
}

